import React from 'react';
import { CheckIcon, ErrorIcon } from '../common/Feedback/icons';

const ValidationIcon = ({ isValid, customErrorIcon }) => {
  const ErrorIconComponent = customErrorIcon || ErrorIcon;

  return (
    <span>
      {isValid ? <CheckIcon size={15} /> : <ErrorIconComponent size={15} fillColor="#6E6E71" />}
    </span>
  );
};

export default ValidationIcon;
